export const GENDER_ENUMS = {
    MALE: "Male",
    FEMALE: "Female",
};

export const gender_dropdown_options = Object.values(GENDER_ENUMS).map(
    (value, idx) => ({
        id: `${value}-${idx}`,
        label: value,
        value,
        selectedLabel: value,
    })
);
